
<div class="loader">
  <span class="spinner-border spinner-border-sm align-middle"></span>  {{'TRANSLATE.LOADING_MESSAGE' | translate}}
</div>
